import { render, staticRenderFns } from "./teamMember.vue?vue&type=template&id=6dd8518a&scoped=true&"
import script from "./teamMember.vue?vue&type=script&lang=js&"
export * from "./teamMember.vue?vue&type=script&lang=js&"
import style0 from "./teamMember.vue?vue&type=style&index=0&id=6dd8518a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd8518a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6dd8518a')) {
      api.createRecord('6dd8518a', component.options)
    } else {
      api.reload('6dd8518a', component.options)
    }
    module.hot.accept("./teamMember.vue?vue&type=template&id=6dd8518a&scoped=true&", function () {
      api.rerender('6dd8518a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2hiWuE2xdsleJ/JS/teamMember.vue"
export default component.exports